import React, { useEffect, useMemo, useState } from "react";
import ColumnComponent from "../../ColumnComponent/ColumnComponent";
import OrderBox from "../../OrderBoxV2/OrderBoxV2";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import PerfectScrollbar from "react-perfect-scrollbar";
import OrderDriverBox from "../../OrderDriverBox/OrderDriverBox";

type Props = {
  isAdmin?: boolean;
  isDriver?: boolean;
  title?: string;
  statusFilter?: "PREPARED" | "IN_DELIVERY";
};
const ProcessedColumn = ({ isAdmin, isDriver, title, statusFilter }: Props) => {
  const orderState = useSelector((state: RootState) => state.order);

  const [orders, setOrders] = useState<any>(<div>Waiting...</div>);

  // Filter orders by status if statusFilter is provided (memoized to prevent infinite loops)
  const filteredOrders = useMemo(() => {
    return statusFilter
      ? orderState.processedOrders.filter(
          (order: any) => order.status === statusFilter,
        )
      : orderState.processedOrders;
  }, [orderState.processedOrders, statusFilter]);

  useEffect(() => {
    if (!orderState.loadingOrders) {
      if (orderState.ordersFailed) {
        //     tODO ovde prikaz ako se desila greska prilikom ucitavanja porudzbina
      } else {
        if (filteredOrders.length === 0) {
          setOrders([]);
        } else {
          let sortedOrder = [...filteredOrders];
          sortedOrder.sort((a: any, b: any) => b.id - a.id);
          setOrders(
            sortedOrder.map((order: any) => {
              return isDriver ? (
                <OrderDriverBox processed={true} key={order.id} order={order} isAdmin={isAdmin} />
              ) : (
                <OrderBox
                  processed={true}
                  isDriver={isDriver}
                  key={order.id}
                  order={order}
                  isAdmin={isAdmin}
                />
              );
            }),
          );
        }
      }
    }
  }, [filteredOrders, orderState.loadingOrders]);

  return (
    <ColumnComponent
      leftSideLabel={title || ""}
      leftSideNumber={filteredOrders.length.toString()}
      style={{ flex: "4" }}
    >
      <PerfectScrollbar style={{ padding: "4px" }}>{orders}</PerfectScrollbar>
    </ColumnComponent>
  );
};

export default ProcessedColumn;
